import getters from './getters'
import mutations from './mutations'
import actions from './actions'
const state = {
  survoyorList: '',
  activeSurvoyorList: '',
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/survoyor/index.js